import React from 'react';

const AdditionalSingleService = ({ icon, title, content }) => {
    return (
        <div className="section__title tw-flex section__title-3 mb-25 wow fadeInUp" data-wow-delay=".2s">
            <div className='section__title__icon'>
                {icon}
            </div>
            <div className='section__title__content'>
                <h3>{title}</h3>
                <p className="mt-2">
                    {content}
                </p>
            </div>
        </div>
    )
};

export default AdditionalSingleService;
